import { gql } from '@apollo/client';

export const GET_TENANT_BY_SLUG = gql`
  query GetTenantBySlug($slug: String!) {
    tenantBySlug(slug: $slug)
      @rest(
        type: "Tenant"
        path: "/tenant/slug?slug={args.slug}"
        method: "GET"
      ) {
      id
      name
      slug
      logoUrl
      faviconUrl
      enableClientPortal
    }
  }
`;
